import { component } from 'picoapp';
import Navigation from 'utils/navigation';

export default component((node, ctx) => {
  /**
   * Data + elements
   */
  const config = JSON.parse(node.dataset.config);
  let isFixed = false;

  const navEl = node.querySelector('.js-nav');
  const menuBtn = node.querySelector('.js-menuBtn');
  const searchInput = node.querySelector('.js-searchInput');
  const searchOutput = node.querySelector('.js-searchOutput');
  const cartBtn = node.querySelector('.js-cartBtn');

  /**
   * Functions
   */
  const fix = () => {
    isFixed = true;
    node.classList.add(config.fixedClass);
    config.bodyScrolledClasses.forEach((className) => document.body.classList.add(className));
  };

  const unfix = () => {
    isFixed = false;
    node.classList.remove(config.fixedClass);
    config.bodyScrolledClasses.forEach((className) => document.body.classList.remove(className));
  };

  const handleScroll = () => {
    const { initialHeights } = config;
    const keys = Object.keys(initialHeights).sort();
    const breakpoint = keys.find((key, index) => window.innerWidth > parseInt(keys[index], 10) && window.innerWidth < parseInt(keys[index + 1], 10)) || keys[keys.length - 1]; // eslint-disable-line
    const initialHeight = initialHeights[breakpoint];

    if (window.scrollY > initialHeight && isFixed === false) {
      fix();
    } else if (window.scrollY <= initialHeight && isFixed === true) {
      unfix();
    }
  };

  const initNav = () => {
    const navigation = new Navigation(navEl);
    const listElements = navEl.querySelectorAll('.js-listItem');

    listElements.forEach((li) => {
      if (li.querySelector('.js-popup')) {
        li.addEventListener('mouseenter', () => {
          if (window.innerWidth >= 1024) {
            navigation.openPopup(li);
          }
        });

        li.addEventListener('mouseleave', () => {
          if (window.innerWidth >= 1024) {
            navigation.closePopup(li);
          }
        });
      }
    });
  };

  const initSearch = async () => {
    const LiveSearch = (await import(/* webpackChunkName: "live-search" */ 'modules/live-search')).default;
    (() => new LiveSearch({
      input: searchInput,
      output: searchOutput,
      outputActiveClass: config.searchOutputActiveClass,
      collectionItemClass: config.collectionItemClass,
      productItemClass: config.productItemClass,
      ctx,
    }))();
  };

  const initCartBtn = () => {
    const countOutput = cartBtn.querySelector('.js-countOutput');

    ctx.on('cart:updated', ({ cart }) => {
      const itemCount = parseInt(cart.itemCount, 10);
      countOutput.textContent = itemCount > 0 ? cart.itemCount : '';
    });

    if (cartBtn.dataset.triggerCartDrawer === 'true') {
      cartBtn.addEventListener('click', (event) => {
        event.preventDefault();
        ctx.emit('cart:open');
      });
    }
  };

  const init = () => {
    handleScroll();
    initNav();
    initCartBtn();
    ctx.on('window:scroll', handleScroll);
    menuBtn.addEventListener('click', () => ctx.emit('mobileNav:open'));
    searchInput.addEventListener('click', () => initSearch());
  };

  /**
   * Init
   */
  init();
});
